import { useContext } from "react";
import { useEmptyColumnHandling } from "./EmptyColumnHandlingProvider";
import { LayoutGridContainerDefaultPropsContext, } from "./LayoutGridContainerDefaultPropsContext";
import { computeColumnCounts } from "./helpers/computeColumnCounts";
export function useLayoutGridContainerComputedProps(props) {
    var _a, _b, _c, _d, _e, _f;
    const defaults = useContext(LayoutGridContainerDefaultPropsContext);
    const emptyColumnHandling = useEmptyColumnHandling(props.node.emptyColumnHandling);
    const { node, gridContainer } = props;
    const { cells } = node;
    const rowSpacing = (_b = (_a = node.rowSpacing) !== null && _a !== void 0 ? _a : gridContainer === null || gridContainer === void 0 ? void 0 : gridContainer.rowSpacing) !== null && _b !== void 0 ? _b : defaults.rowSpacing;
    const columnSpacing = (_d = (_c = node.columnSpacing) !== null && _c !== void 0 ? _c : gridContainer === null || gridContainer === void 0 ? void 0 : gridContainer.columnSpacing) !== null && _d !== void 0 ? _d : defaults.rowSpacing;
    // recompute the number of grid columns if empty columns are excluded
    const columns = computeColumnCounts(cells, emptyColumnHandling);
    const sx = (_f = (_e = node.gridContainerSx) !== null && _e !== void 0 ? _e : gridContainer === null || gridContainer === void 0 ? void 0 : gridContainer.sx) !== null && _f !== void 0 ? _f : defaults.sx;
    return {
        rowSpacing,
        columnSpacing,
        columns,
        emptyColumnHandling,
        sx,
    };
}
//# sourceMappingURL=useLayoutGridContainerComputedProps.js.map